// ============================================================================
// LA DERNIÈRE LECTURE LANCÉE ÉCRIT L'ÉCRAN — une réponse plus ancienne se tait (Forme JD).
//
// POURQUOI. Un écran relit dès qu'une dépendance change (une frappe, un magasin, un filtre, « Afficher plus »). Deux
// lectures se croisent : celle de la valeur PRÉCÉDENTE revient après celle de la valeur courante, et l'écran affiche les
// résultats d'une recherche que le champ ne dit plus, les lignes d'un filtre qu'on vient de quitter, les données d'un
// magasin sous le bandeau d'un autre. Chaque réponse est juste : c'est leur ORDRE qui ment.
//
// L'USAGE : `const latest = useLatest();` dans le composant, puis dans la lecture
//    `const isLatest = latest();` avant l'appel et `if (!isLatest()) return;` avant CHAQUE écriture de sa réponse —
//    résultat, échec et indicateur de chargement compris.
// ⚠️ UN COMPTEUR, PAS UN DRAPEAU D'EFFET : la lecture vit souvent dans un `useCallback` appelé par plusieurs effets et
//    par « Réessayer » — seul un compteur partagé par toutes ses invocations sait laquelle est la dernière.
// ============================================================================
import { useCallback, useRef } from 'react';

/** Rend `latest()` : chaque appel ouvre une lecture et rend `isLatest()`, vrai tant qu'aucune autre n'a été ouverte. */
export function useLatest(): () => () => boolean {
  const seq = useRef(0);
  return useCallback(() => {
    const mine = ++seq.current;
    return () => mine === seq.current;
  }, []);
}
